import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    CircularProgress,
    Typography,
    FormControlLabel,
    Switch,
    FormGroup
} from "@material-ui/core";

import Alert from '@material-ui/lab/Alert';

import { Cookies } from "react-cookie-consent";

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    updatePlazzPrivacy
} from 'src/shared_modules/veu-visitors-plazz/actions/user';

import {
    showStaticContent,
} from "src/shared_modules/veu-visitors-core/actions/content";

import MarketingConsentButton from "src/shared_modules/veu-visitors-core/components/common/marketingConsentButton";

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import '../popovers.css';


class PopoverPrivacy extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error: "",
            allClicked: false,
            isBusy: false,
            failed: false,
            fields: {
                person_chat: false,
                person_email_flag: false,
                visible: false,
                person_photo_flag: false,
            },
        }
    }

    componentDidMount() {
        this.clickSend = this.clickSend.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);

        if (!this.props.event.hasPlazzConvention)
            return;

        this.setState({
            fields: {
                person_chat: this.props.user.plazz.privacy.person_chat,
                person_email_flag: this.props.user.plazz.privacy.person_email_flag,
                visible: this.props.user.plazz.privacy.visible,
                person_photo_flag: this.props.user.plazz.privacy.person_photo_flag,
            }
        });
    }

    async clickSend(all) {
        if (this.state.isBusy)
            return;

        this.setState({
            isBusy: true,
            failed: false,
            error: "",
        });

        if (all) {
            let fields = {
                person_chat: true,
                person_email_flag: true,
                visible: true,
                person_photo_flag: true,
            };

            this.setState({
                allClicked: true,
                fields: fields
            });
            await this.props.updatePlazzPrivacy(fields);

        } else {
            await this.props.updatePlazzPrivacy(this.state.fields);
        }

        //console.log("trackEvent - UserAccount - change - Privacy Setting");
        this.props.trackEvent("UserAccount", "change", "Privacy Setting");

        this.setState({
            isBusy: false,
            allClicked: false,
        });

        if (this.props.openInUserTabContainer === false) {
            this.props.hidePopover("Privacy");

            // see also room.js - handlePanoReady() function
            if (this.props.event.onAir && !this.props.event.enablePreregister) {
                // admin 3.4.0+, enableTutorial JED
                if (this.props.event.enableTutorial) {
                    if (!Cookies.get("readTutorial")) {
                        // show tutorial for absolute beginners
                        if (this.props.event.enableTutorial) {
                            this.props.showStaticContent("tutorial.html");
                            Cookies.set("readTutorial", "true", { expires: 365 }, { secure: true });
                        }
                    }
                }
            }
        }
    }


    handleSwitchChange(event) {
        // update the field value
        let fields = this.state.fields;
        fields[event.target.name] = event.target.checked;
        this.setState({
            fields: fields,
        });
    }


    render() {
        return (<form className="user" onSubmit={(e) => { e.preventDefault(); }} >
            <Typography paragraph align="center" color="primary" variant="h6" component="h1" className="user-form">
                <Translate>popovers.first-login.title</Translate>
            </Typography>

            <Typography paragraph align="left" variant="body1" component="div" color="primary">
                <Translate>popovers.first-login.message</Translate>
            </Typography>
            <FormGroup >
                <FormControlLabel
                    className="privacySettingLabel"
                    control={
                        <Switch
                            checked={this.state.fields.person_chat}
                            onChange={this.handleSwitchChange}
                            name="person_chat"
                            color="secondary"
                        />
                    }
                    label={<Translate>popovers.privacy.chat</Translate>}
                />
                <FormControlLabel
                    className="privacySettingLabel"
                    control={
                        <Switch
                            checked={this.state.fields.person_email_flag}
                            onChange={this.handleSwitchChange}
                            name="person_email_flag"
                            color="secondary"
                        />
                    }
                    label={<Translate>popovers.privacy.email</Translate>}
                />
                <FormControlLabel
                    className="privacySettingLabel"
                    control={
                        <Switch
                            checked={this.state.fields.visible}
                            onChange={this.handleSwitchChange}
                            name="visible"
                            color="secondary"
                        />
                    }
                    label={<Translate>popovers.privacy.visible</Translate>}
                />
                <FormControlLabel
                    className="privacySettingLabel"
                    control={
                        <Switch
                            checked={this.state.fields.person_photo_flag}
                            onChange={this.handleSwitchChange}
                            name="person_photo_flag"
                            color="secondary"
                        />
                    }
                    label={<Translate>popovers.privacy.photo</Translate>}
                />
                <p></p>
                {this.state.failed && <React.Fragment>
                    <Alert variant="outlined" severity="error">
                        <Translate>{this.state.error}</Translate>
                    </Alert>
                    <p></p>
                </React.Fragment>}
                <div className="marketing-consent-button">
                    <MarketingConsentButton />
                </div>

                <div className="user-form-button-bar">
                    <Button variant="contained"
                        color="secondary"
                        onClick={() => { this.clickSend(true); }}
                        type="submit"
                        endIcon={this.state.isBusy && this.state.allClicked && <CircularProgress color="inherit" size={20} />}
                    >
                        <Translate>popovers.privacy.confirm-all</Translate>
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => { this.clickSend(false); }}
                        type="submit"
                        endIcon={this.state.isBusy && !this.state.allClicked && <CircularProgress color="inherit" size={20} />}
                    >
                        <Translate>popovers.privacy.confirm</Translate>
                    </Button>
                </div>

            </FormGroup>
        </form>);
    }
}

PopoverPrivacy.propTypes = {
    event: PropTypes.object,
    openInUserTabContainer: PropTypes.bool,
};


/*
 * ---------------------------------------------------------------------
 * PopoverFirstLoginPrivacy Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = (state, ownProps) => {
    return {
        event: state.event,
        user: state.user,
        openInUserTabContainer: state.popovers.openInUserTabContainer,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    updatePlazzPrivacy,
    showStaticContent,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withMatomo(PopoverPrivacy));
